import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "file-arae" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("NEW+ ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", null, "Create A New Green Vote.", -1)
const _hoisted_4 = { style: {"margin-left":"10px"} }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { style: {"width":"120px"} }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Id ")
const _hoisted_8 = { style: {"width":"300px"} }
const _hoisted_9 = { style: {"width":"120px"} }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Dao Id ")
const _hoisted_11 = { style: {"width":"300px"} }
const _hoisted_12 = { style: {"width":"120px"} }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Dao Name ")
const _hoisted_14 = { style: {"width":"300px"} }
const _hoisted_15 = { style: {"width":"120px"} }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Title ")
const _hoisted_17 = { style: {"width":"300px"} }
const _hoisted_18 = { style: {"width":"120px"} }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Description ")
const _hoisted_20 = { style: {"width":"300px"} }
const _hoisted_21 = { style: {"width":"120px"} }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("End Time ")
const _hoisted_23 = { style: {"width":"300px"} }
const _hoisted_24 = { style: {"width":"120px"} }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Pay Token ")
const _hoisted_26 = { style: {"width":"300px"} }
const _hoisted_27 = { style: {"width":"120px"} }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Pay Value ")
const _hoisted_29 = { style: {"width":"300px"} }
const _hoisted_30 = { style: {"width":"120px"} }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Pay To ")
const _hoisted_32 = { style: {"width":"300px"} }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("cancel")
const _hoisted_34 = /*#__PURE__*/_createTextVNode("confirm")
const _hoisted_35 = { class: "card-header" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("Id: ")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Owner: ")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("Owner: ")
const _hoisted_39 = /*#__PURE__*/_createTextVNode("Receiver: ")
const _hoisted_40 = { style: {"float":"right"} }
const _hoisted_41 = { style: {"float":"right"} }
const _hoisted_42 = { style: {"float":"right"} }
const _hoisted_43 = /*#__PURE__*/_createTextVNode("Aggree")
const _hoisted_44 = /*#__PURE__*/_createTextVNode("Against")
const _hoisted_45 = /*#__PURE__*/_createTextVNode("Revoke")
const _hoisted_46 = /*#__PURE__*/_createTextVNode("Prev ")
const _hoisted_47 = /*#__PURE__*/_createTextVNode("Next ")

import { ref } from "vue"
import { connected, connectState } from "../libs/connect"
import * as constant from "../constant"
import * as element from "../libs/element"
import * as tools from "../libs/tools"

import { ERC20 } from "../libs/erc20"
import { GreenDao } from "../libs/greendao"
import { GreenVote } from "../libs/greenvote"


const __default__ = {
  name: 'VotesPage',
  props: {
  }
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

  
const greendao = new GreenDao();
const greenvote = new GreenVote();

const activeName = connectState.activeName;
const loadStatus = ref(false);
const loadDrawerStatus = ref(false);

const showAddNewVoteVisiable = ref(false);

const daoId = ref(0);
const daoName = ref('');
const voteId = ref(0);
const voteTitle = ref('');
const voteDescription = ref('');
const voteToken = ref('');
const voteValue = ref(0);
const voteTo = ref('');
const voteEndTime = ref('');

const greenVoteList = ref(new Array());
const hasMore = ref(false);
const pageSize = ref(6);
const pageCount = ref(0);

const zeroAddress = '0x0000000000000000000000000000000000000000';
const timeFormat = "YYYY/MM/DD hh:mm:ss";

const svg = `
        <path class="path" d="
          M 30 15
          L 28 17
          M 25.61 25.61
          A 15 15, 0, 0, 1, 15 30
          A 15 15, 0, 1, 1, 27.99 7.5
          L 15 15
        " style="stroke-width: 4px; fill: rgba(0, 0, 0, 0)"/>
      `;
     
//address explore url
const tokenExplorerUrl = (address:string, tokenId:string = '') => {
  for(const i in constant.chainList){
    if(connectState.chainId === constant.chainList[i].chainId){
      const blockExplorerUrls = constant.chainList[i].blockExplorerUrls;
      if(tokenId != ''){
        return `${blockExplorerUrls}/token/${address}?a=${tokenId}#inventory`
      }
      return `${blockExplorerUrls}/token/${address}`
    }
  }
  return address;
}

//address explore url
const addressExplorerUrl = (address:string) => {
  for(const i in constant.chainList){
    if(connectState.chainId === constant.chainList[i].chainId){
      const blockExplorerUrls = constant.chainList[i].blockExplorerUrls;
      return `${blockExplorerUrls}/address/${address}`
    }
  }
  return address;
}

//transaction explore url
const transactionExplorerUrl = (transaction:string) => {
  for(const i in constant.chainList){
    if(connectState.chainId === constant.chainList[i].chainId){
      const blockExplorerUrls = constant.chainList[i].blockExplorerUrls;
      return blockExplorerUrls + '/tx/' + transaction;
    }
  }
  return transaction;
}

//get block chain native currency
const getTokenCurencyName = async (token:string) => {
  if(token === zeroAddress){
    for(const i in constant.chainList){
      if(constant.chainList[i].chainId === connectState.chainId){
        return constant.chainList[i].nativeCurrency;
      }
    }
  }else{
    const erc20 = new ERC20(token);
    return await erc20.symbol();
  }
}

//on click to copy address
const onClickToCopy = async (content:string) => {
  tools.clickToCopy(content);
  
  element.elMessage('success', 'Copy ' + content + ' to clipboard success.');     
};

//get dao id
const getDaoId = () => {
  const daoId = tools.getUrlParamter('daoId');
  try{
    return Number(daoId);
  }catch(e){
    return 0;
  }
}

//update dao name by dao id
const updateDaoName = async (daoId:Number) => {
  const daoInfo = await greendao.getDaoInfoById(daoId);
  daoName.value = daoInfo.daoName;
}

//click to open the drawer to create a new vote
const onAddNewVoteOpen = async () => {
  await updateDaoName(daoId.value);
}

//click to open the drawer to create a new vote
const onAddGreenVote = async () => {
  daoId.value = getDaoId();
  voteId.value = 0;
  voteTitle.value = '';
  voteDescription.value = '';
  voteToken.value = zeroAddress;
  voteValue.value = 0;
  voteTo.value = zeroAddress;

  const now = new Date();
  now.setTime(now.getTime() + 30*24*3600*1000);

  voteEndTime.value = now.toLocaleString();  

  showAddNewVoteVisiable.value = true;
}

//click to open the drawer to edit the vote
const onEditGreenVote = async (voteInfo:any) => {
  daoId.value = voteInfo.daoId;
  voteId.value = voteInfo.voteId;
  voteTitle.value = voteInfo.voteName;
  voteDescription.value = voteInfo.voteDesc;
  voteToken.value = voteInfo.voteToken;
  voteValue.value = voteInfo.voteValue;
  voteTo.value = voteInfo.voteTo;

  voteEndTime.value = (new Date(voteInfo.endTime*1000)).toLocaleString();

  showAddNewVoteVisiable.value = true; 
}

//click to cancle vote update or create
const cancelVoteUpdate = async () => {
  showAddNewVoteVisiable.value = false;
}

//click to confirm to update or create the vote
const confirmVoteUpdate = async () => {
  try{
    loadDrawerStatus.value = true;

    const endTime = new Date(voteEndTime.value).getTime()/1000;

    if(voteId.value > 0){
      const tx = await greenvote.updateVote(voteId.value, voteTitle.value, voteDescription.value, endTime);
      connectState.transactions.value.unshift(tx);
      connectState.transactionCount.value++;
      const msg = `<div><span>Update vote success! Transaction: </span><a href="${transactionExplorerUrl(tx)}" target="_blank">${tx}</a></div>`;
      element.elMessage('success', msg, true);   
    }else{
      const tx = await greenvote.mint(voteTitle.value, voteDescription.value, daoId.value, voteValue.value, voteToken.value, voteTo.value, endTime);
      connectState.transactions.value.unshift(tx);
      connectState.transactionCount.value++;
      const msg = `<div><span>Create vote success! Transaction: </span><a href="${transactionExplorerUrl(tx)}" target="_blank">${tx}</a></div>`;
      element.elMessage('success', msg, true);    
    }

    showAddNewVoteVisiable.value = false;

    handleClick();
  }catch(e){
    element.alertMessage(e);
  }finally{
    loadDrawerStatus.value = false;
  }
}

//click to delete a green vote
const onDeleteGreenVote = async (voteId:number) => {
  try{
    const tx = await greenvote.burn(voteId);
    connectState.transactions.value.unshift(tx);
    connectState.transactionCount.value++;
    const msg = `<div><span>Delete vote success! Transaction: </span><a href="${transactionExplorerUrl(tx)}" target="_blank">${tx}</a></div>`;
    element.elMessage('success', msg, true);       

    handleClick();
  }catch(e){
    element.alertMessage(e);
  }
}

//click to cast a vote
const onVote = async (voteId:number, voteType:string) => {
  let status = 0;

  if(voteType === 'aggree'){
    status = 1;
  }else if(voteType === 'against'){
    status = 2;
  }else{
    status = 0;
  }

  try{
    const tx = await greenvote.vote(voteId, status);
    connectState.transactions.value.unshift(tx);
    connectState.transactionCount.value++;
    const msg = `<div><span>Cast the vote success! Transaction: </span><a href="${transactionExplorerUrl(tx)}" target="_blank">${tx}</a></div>`;
    element.elMessage('success', msg, true);       

    handleClick();
  }catch(e){
    element.alertMessage(e);
  }  
}

//get green vote infos by page size and page count
const getGreenVoteCount = async (onlyOwner:boolean) => {
  daoId.value = getDaoId();

  const indexs = await greenvote.getVoteIndexsByPageCount(pageSize.value, pageCount.value, daoId.value, onlyOwner);

  if(indexs.length < pageSize.value){
    hasMore.value = false;
  }else{
    hasMore.value = true;
  }

  const infoList = new Array();
  for(const i in indexs){
    const res = await greenvote.getVoteInfoById(indexs[i]);

    res.voteEnded = res.endTime < (new Date().getTime()/1000);
    res.voteOwner = await greenvote.ownerOf(indexs[i]);
    res.tokenSymbol = await getTokenCurencyName(res.voteToken);
    res.isOwner = res.voteOwner.toLowerCase() === connectState.userAddr.value.toLowerCase();

    //if dao not exists, skip
    try{
      const daoInfo = await greendao.getDaoInfoById(res.daoId);
      res.daoName = daoInfo.daoName;
      res.daoAvatar = daoInfo.daoAvatar;
      res.daoWebsite = daoInfo.daoWebsite;
      res.daoDesc = daoInfo.daoDesc;
      res.daoOwner = daoInfo.daoOwner;
      res.daoPublic = daoInfo.daoPublic;
      res.daoMembers = daoInfo.daoMembers;
    }catch(e){
      continue;
    }

    infoList.push(res);
  }

  greenVoteList.value = infoList;  
}

//on click for prev page
const onHandlePrev = async () => {
  if(pageCount.value > 0){
    pageCount.value--;
  }
  handleClick();
}

//on click for next page
const onHandleNext = async () => {
  if(hasMore.value){
    pageCount.value++;
  }
  handleClick();
}

//handle page refresh
const handleClick = async () => {
  //wait for the active name change
  await tools.sleep(100);
    
  connectState.activeName.value = activeName.value;
  tools.setUrlParamter('activeName', activeName.value);
  try{
    loadStatus.value = true;
    if (!(await connected())){
      greenVoteList.value = new Array();
      return;
    }

    if(pageCount.value < 0){
      pageCount.value = 0;
    }

    const onlyOwner = activeName.value === 'mine';

    await getGreenVoteCount(onlyOwner);

  }catch(e){
    greenVoteList.value = new Array();
  }finally{
    loadStatus.value = false;
  }
}

//clean search content and bind search callback function
connectState.search = '';
connectState.searchCallback = handleClick;
//try get activeName from the url paramter
try{
  activeName.value = tools.getUrlParamter('activeName');
  if(activeName.value != 'all' && 
    activeName.value != 'mine'){
    activeName.value = 'all';
  }
}catch(e){
  activeName.value = 'all';
}
//update page size
handleClick();

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_document_copy = _resolveComponent("document-copy")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_Edit = _resolveComponent("Edit")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, { style: {"background-color":"#ffffff"} }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tabs, {
              modelValue: _unref(activeName),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(activeName) ? (activeName).value = $event : null)),
              class: "file-tabs",
              onTabClick: handleClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tab_pane, {
                  label: "All",
                  name: "all"
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "Mine",
                  name: "mine"
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              style: {"float":"right","margin-right":"50px"},
              onClick: onAddGreenVote
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_el_drawer, {
              modelValue: showAddNewVoteVisiable.value,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((showAddNewVoteVisiable).value = $event)),
              direction: "rtl",
              "destroy-on-close": "",
              onOpened: onAddNewVoteOpen
            }, {
              header: _withCtx(() => [
                _hoisted_3
              ]),
              default: _withCtx(() => [
                _createElementVNode("table", _hoisted_4, [
                  (voteId.value > 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                        _createElementVNode("td", _hoisted_6, [
                          _hoisted_7,
                          _createVNode(_component_el_popover, {
                            placement: "top-start",
                            title: "Vote Id",
                            width: 200,
                            trigger: "hover",
                            content: "The id of the green vote."
                          }, {
                            reference: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_QuestionFilled)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("td", _hoisted_8, [
                          _createVNode(_component_el_input, {
                            modelValue: voteId.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((voteId).value = $event)),
                            disabled: ""
                          }, {
                            append: _withCtx(() => [
                              _createVNode(_component_el_icon, {
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (onClickToCopy(voteId.value)))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_document_copy)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_9, [
                      _hoisted_10,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Dao Id",
                        width: 200,
                        trigger: "hover",
                        content: "The dao id of the green dao. The vote must be published through the dao."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_11, [
                      _createVNode(_component_el_input, {
                        modelValue: daoId.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((daoId).value = $event)),
                        onChange: _cache[5] || (_cache[5] = ($event: any) => (updateDaoName(daoId.value))),
                        disabled: voteId.value > 0
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (onClickToCopy(daoId.value)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_document_copy)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_12, [
                      _hoisted_13,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Dao Name",
                        width: 200,
                        trigger: "hover",
                        content: "The name of the green dao."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_14, [
                      _createVNode(_component_el_input, {
                        modelValue: daoName.value,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((daoName).value = $event)),
                        disabled: ""
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (onClickToCopy(daoName.value)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_document_copy)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_15, [
                      _hoisted_16,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Vote Title",
                        width: 200,
                        trigger: "hover",
                        content: "The title of the green vote."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_17, [
                      _createVNode(_component_el_input, {
                        modelValue: voteTitle.value,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((voteTitle).value = $event))
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (onClickToCopy(voteTitle.value)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_document_copy)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_18, [
                      _hoisted_19,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Vote Description",
                        width: 200,
                        trigger: "hover",
                        content: "The description of the green vote."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_20, [
                      _createVNode(_component_el_input, {
                        modelValue: voteDescription.value,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((voteDescription).value = $event)),
                        type: "textarea",
                        rows: "5"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_21, [
                      _hoisted_22,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Vote End Time",
                        width: 200,
                        trigger: "hover",
                        content: "The end time of the green vote."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_23, [
                      _createVNode(_component_el_date_picker, {
                        modelValue: voteEndTime.value,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((voteEndTime).value = $event)),
                        style: {"width":"100%"},
                        type: "datetime",
                        placeholder: "Pick a Date",
                        format: timeFormat
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_24, [
                      _hoisted_25,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Vote Payment Token",
                        width: 200,
                        trigger: "hover",
                        content: "The token contract for the green vote. You can choose the blockchain native token or the erc20 tokens based on the balance of the dao treassure."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_26, [
                      _createVNode(_component_el_input, {
                        modelValue: voteToken.value,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((voteToken).value = $event)),
                        disabled: voteId.value > 0
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (onClickToCopy(voteToken.value)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_document_copy)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_27, [
                      _hoisted_28,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Vote Pay Value",
                        width: 200,
                        trigger: "hover",
                        content: "The amount of the token value that the vote request for."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_29, [
                      _createVNode(_component_el_input, {
                        modelValue: voteValue.value,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((voteValue).value = $event)),
                        disabled: voteId.value > 0
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (onClickToCopy(voteValue.value)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_document_copy)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_30, [
                      _hoisted_31,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Vote Pay To",
                        width: 200,
                        trigger: "hover",
                        content: "The dest address that the vote payment send to."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_32, [
                      _createVNode(_component_el_input, {
                        modelValue: voteTo.value,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((voteTo).value = $event)),
                        disabled: voteId.value > 0
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (onClickToCopy(voteTo.value)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_document_copy)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ])
                  ])
                ])
              ]),
              footer: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", {
                  style: {"flex":"auto"},
                  "element-loading-text": "Submitting...",
                  "element-loading-spinner": svg,
                  "element-loading-svg-view-box": "-10, -10, 50, 50",
                  "element-loading-background": "#ffffff"
                }, [
                  _createVNode(_component_el_button, { onClick: cancelVoteUpdate }, {
                    default: _withCtx(() => [
                      _hoisted_33
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: confirmVoteUpdate
                  }, {
                    default: _withCtx(() => [
                      _hoisted_34
                    ]),
                    _: 1
                  })
                ])), [
                  [_directive_loading, loadDrawerStatus.value]
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _withDirectives((_openBlock(), _createBlock(_component_el_main, {
          style: {"height":"450px","margin-top":"20px"},
          "element-loading-text": "Loading...",
          "element-loading-spinner": svg,
          "element-loading-svg-view-box": "-10, -10, 50, 50",
          "element-loading-background": "#ffffff"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(greenVoteList.value, (info) => {
                  return (_openBlock(), _createBlock(_component_el_col, {
                    key: info.voteId,
                    span: 8
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_card, { class: "box-card" }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", _hoisted_35, [
                            _createVNode(_component_el_popover, {
                              placement: "bottom-start",
                              width: 230,
                              title: "Dao Info"
                            }, {
                              reference: _withCtx(() => [
                                _createVNode(_component_el_link, {
                                  type: "success",
                                  target: "_blank",
                                  href: info.daoWebsite
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_avatar, {
                                      src: info.daoAvatar,
                                      size: "small"
                                    }, null, 8, ["src"])
                                  ]),
                                  _: 2
                                }, 1032, ["href"])
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("h4", null, "Name: " + _toDisplayString(info.daoName), 1),
                                _createElementVNode("h4", null, [
                                  _hoisted_36,
                                  _createVNode(_component_el_link, {
                                    type: "success",
                                    target: "_blank",
                                    href: tokenExplorerUrl(_unref(greendao).getAddress(),info.daoId)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(info.daoId), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["href"])
                                ]),
                                _createElementVNode("h4", null, [
                                  _hoisted_37,
                                  _createVNode(_component_el_link, {
                                    type: "success",
                                    target: "_blank",
                                    href: addressExplorerUrl(info.daoOwner)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(info.daoOwner), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["href"])
                                ]),
                                _createElementVNode("h4", null, "Members: " + _toDisplayString(info.daoMembers), 1),
                                _createElementVNode("h4", null, "Public: " + _toDisplayString(info.daoPublic), 1),
                                _createElementVNode("h4", null, "Description: " + _toDisplayString(info.daoDesc), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_el_popover, {
                              placement: "bottom-start",
                              width: 230,
                              title: "Vote Info"
                            }, {
                              reference: _withCtx(() => [
                                _createElementVNode("span", null, [
                                  _createVNode(_component_el_link, {
                                    type: "success",
                                    target: "_blank",
                                    href: tokenExplorerUrl(_unref(greenvote).getAddress(),info.voteId)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(info.voteName), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["href"])
                                ])
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("h4", null, "Title: " + _toDisplayString(info.voteName), 1),
                                _createElementVNode("h4", null, [
                                  _hoisted_38,
                                  _createVNode(_component_el_link, {
                                    type: "success",
                                    target: "_blank",
                                    href: addressExplorerUrl(info.voteOwner)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(info.voteOwner), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["href"])
                                ]),
                                _createElementVNode("h4", null, [
                                  _hoisted_39,
                                  _createVNode(_component_el_link, {
                                    type: "success",
                                    target: "_blank",
                                    href: addressExplorerUrl(info.voteTo)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(info.voteTo), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["href"])
                                ]),
                                _createElementVNode("h4", null, "Description: " + _toDisplayString(info.voteDesc), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createElementVNode("span", null, [
                              (_unref(activeName) === 'mine')
                                ? (_openBlock(), _createBlock(_component_el_button, {
                                    key: 0,
                                    type: "danger",
                                    style: {"float":"right"},
                                    size: "small",
                                    onClick: ($event: any) => (onDeleteGreenVote(info.voteId))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Delete)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              (_unref(activeName) === 'mine')
                                ? (_openBlock(), _createBlock(_component_el_button, {
                                    key: 1,
                                    type: "primary",
                                    style: {"float":"right"},
                                    size: "small",
                                    onClick: ($event: any) => (onEditGreenVote(info))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Edit)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_row, null, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(info.voteDesc), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_row, { style: {"float":"right"} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_progress, {
                                style: {"width":"220px","float":"right"},
                                "text-inside": true,
                                "stroke-width": 20,
                                percentage: (100*info.voteAggree/info.daoMembers),
                                status: "success"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, "Aggree: " + _toDisplayString(info.voteAggree + '/' + info.daoMembers), 1)
                                ]),
                                _: 2
                              }, 1032, ["percentage"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_row, { style: {"float":"right"} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_progress, {
                                style: {"width":"220px","float":"right"},
                                "text-inside": true,
                                "stroke-width": 20,
                                percentage: (100*info.voteAgainst/info.daoMembers),
                                status: "exception"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, "Against: " + _toDisplayString(info.voteAgainst + '/' + info.daoMembers), 1)
                                ]),
                                _: 2
                              }, 1032, ["percentage"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_row, { style: {"float":"right"} }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_40, "Request Token: " + _toDisplayString(info.voteValue + ' ' + info.tokenSymbol), 1)
                            ]),
                            _: 2
                          }, 1024),
                          (info.voteEnded === false && info.votePayed === false)
                            ? (_openBlock(), _createBlock(_component_el_row, {
                                key: 0,
                                style: {"float":"right"}
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_41, "Endtime: " + _toDisplayString((new Date(info.endTime*1000)).toLocaleString()), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (info.voteEnded === true || info.votePayed === true)
                            ? (_openBlock(), _createBlock(_component_el_row, {
                                key: 1,
                                style: {"float":"right"}
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_42, "Vote Result: " + _toDisplayString(info.voteSuccess ? 'pass' : 'fail'), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          _createVNode(_component_el_row, { style: {"float":"right"} }, {
                            default: _withCtx(() => [
                              (info.voteEnded === false && info.votePayed === false)
                                ? (_openBlock(), _createBlock(_component_el_link, {
                                    key: 0,
                                    type: "primary",
                                    style: {"float":"right"},
                                    onClick: ($event: any) => (onVote(info.voteId, 'aggree'))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_43
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              (info.voteEnded === false && info.votePayed === false)
                                ? (_openBlock(), _createBlock(_component_el_link, {
                                    key: 1,
                                    type: "primary",
                                    style: {"float":"right"},
                                    onClick: ($event: any) => (onVote(info.voteId, 'against'))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_44
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              (info.voteEnded === false && info.votePayed === false)
                                ? (_openBlock(), _createBlock(_component_el_link, {
                                    key: 2,
                                    type: "primary",
                                    style: {"float":"right"},
                                    onClick: ($event: any) => (onVote(info.voteId, 'revoke'))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_45
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })), [
          [_directive_loading, loadStatus.value]
        ]),
        _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_button, {
                type: "primary",
                style: {"margin-top":"10px"},
                onClick: onHandlePrev
              }, {
                default: _withCtx(() => [
                  _hoisted_46
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                style: {"margin-top":"10px"},
                onClick: onHandleNext,
                disabled: !hasMore.value
              }, {
                default: _withCtx(() => [
                  _hoisted_47
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})